export const STRINGS_EN = {
  HOME: {
    HERO: {
      TITLE: "Hi, Hello there! Nice to meet you!",
      SUBTITLE: "Full-Stack Developer",
      DESCRIPTION:
        "I'm a graduated electrical engineer who transitioned into full-stack development. I build interactive web applications with React and I'm expanding into Python and AWS.",
    },
    PROFILE: {
      NAME: "Bryan Cendales",
      PHOTO_URL: "/path-to-your-photo.jpg", // ← Update this with your photo path
      SOCIAL_LINKS: [
        { NAME: "GitHub", URL: "https://github.com/yourusername" },
        { NAME: "LinkedIn", URL: "https://linkedin.com/in/yourusername" },
        // Add more as needed
      ],
      SKILLS: ["React", "JavaScript", "SCSS", "Python", "AWS"],
    },
    TECH_STACK: {
      TITLE: "Tech Stack",
      LEARNING: "Learning",
      STACK: [
        { NAME: "React", LEARNING: false },
        { NAME: "JavaScript", LEARNING: false },
        { NAME: "SCSS", LEARNING: false },
        { NAME: "Python", LEARNING: true },
        { NAME: "AWS", LEARNING: true },
      ],
    },
    PROJECTS: {
      TITLE: "My Projects",
      TRY_LIVE: "Try it Live →",
      PROJECTS_DATA: [
        {
          TITLE: "Roulette",
          ROUTE: "/roulette",
          DESCRIPTION:
            "An interactive spinning wheel to make random selections to play.",
          TECH: ["React", "SCSS"],
        },
        {
          TITLE: "Payment Reminder",
          ROUTE: "/payment-reminder",
          DESCRIPTION:
            "A family-oriented economy manager to check your monthly payments and card subscriptions.",
          TECH: ["React", "SCSS"],
        },
        {
          TITLE: "Simple Kitchen",
          ROUTE: "/simple-kitchen",
          DESCRIPTION:
            "Friendly, simple cooking manager for weekly recipes. Add prices and shopping lists to prepare before going to the mall.",
          TECH: ["React", "SCSS"],
        },
      ],
    },
    CONTACT: {
      TITLE: "Let's Connect",
      EMAIL_ME: "Email Me",
      DESCRIPTION:
        "I'm always open to new opportunities and collaborations. Feel free to reach out!",
      EMAIL: "bn.cendales10@gmail.com",
      LINKS: [
        { NAME: "GitHub", URL: "https://github.com/MrBCendales" },
        {
          NAME: "LinkedIn",
          URL: "https://www.linkedin.com/in/bryann-cendales/",
        },
      ],
    },
    FOOTER: {
      COPYRIGHT: "© 2025 Bryan Cendales. All rights reserved.",
      MADE_WITH: "Made with React & ❤️",
    },
  },
  ROULETTE: {
    TITLE: "Roulette",
    DESCRIPTION:
      "An interactive spinning wheel to make random selections to play.",
    TECH: ["React", "SCSS"],
  },
  PAYMENT_REMINDER: {
    TITLE: "Payment Reminder",
    DESCRIPTION:
      "A family-oriented economy manager to check your monthly payments and card subscriptions.",
    TECH: ["React", "SCSS"],
  },
};
